import styled from "styled-components";
import { keyframes } from "styled-components";
import NextSection from "../general/NextSection";
import { colors } from "../../assets/colors";
import { useSectionCursor } from "../general/Cursor";

{
  /* Intro text animation */
}
const TextShift = keyframes`
  0% {transform: translate(0,100%);}
  100% {transform: translate(0,37.5%);}
`;

const SectionContainer = styled.div`
  width: 100vw;
  height: 150vh;
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
  position: sticky;
  flex-wrap: wrap;
  top: -1px;
  max-width: 100%;
`;

const TitleTextContainer = styled.div`
  background-color: transparent;
  width: fit-content;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;

{
  /* Outlined Text */
}
const TitleText = styled.h1`
  font-size: 8vmin;
  font-family: ReadexPro, sans-serif;
  margin: 0;
  padding: 0;
  -webkit-text-stroke: 0.03em ${colors.black};
  color: transparent;
  font-weight: 900;
  line-height: 82%;
  animation-name: ${TextShift};
  animation-delay: 0.2s;
  animation-duration: 2s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

{
  /* Filled in Text */
}
const TitleTextStill = styled.h1`
  font-size: 8vmin;
  font-family: ReadexPro, sans-serif;
  margin: 0;
  padding: 0;
  color: transparent;
  font-weight: 900;
  line-height: 82%;
  color: ${colors.black};
`;

const LineBreak = styled.div`
  width: 100%;
  height: 0;
`;

const Spacer = styled.div`
  width: 100%;
  height: 50vh;
`;

function AboutHome() {
  const cursorHandlers = useSectionCursor({ color: colors.black });

  return (
    <SectionContainer {...cursorHandlers}>
      {/* <NextSection ScrollNext={150} ScrollAlready={0} color={colors.black} /> */}
      <TitleTextContainer style={{ transform: "translate(0,75%)" }}>
        <TitleText style={{ transform: "translate(0,100%)" }}>
          OUR STARTUPS
        </TitleText>
      </TitleTextContainer>
      <LineBreak />
      <TitleTextContainer style={{ transform: "translate(0,37.5%)" }}>
        <TitleText style={{ transform: "translate(0,100%)" }}>
          OUR STARTUPS
        </TitleText>
      </TitleTextContainer>
      <LineBreak />
      <TitleTextContainer>
        <TitleText style={{ transform: "translate(0,100%)" }}>
          OUR STARTUPS
        </TitleText>
      </TitleTextContainer>
      <LineBreak />
      <TitleTextContainer>
        <TitleTextStill> OUR STARTUPS</TitleTextStill>
      </TitleTextContainer>
      <Spacer />
    </SectionContainer>
  );
}

export default AboutHome;
